import {Button, DatePicker, Form, Input, InputNumber, Modal, Select} from "antd";
import {useState} from "react";
import {useFetch, useMutation} from "../../api";
import {useQueryClient} from "react-query";
import {WorkerForm} from "../../components/forms/worker";
import {FileAddOutlined} from "@ant-design/icons";


export function AddWorker(props) {

    const [form] = Form.useForm();
    const queryClient = useQueryClient()

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true)
        form.resetFields()
    }
    const onCancel = () => {
        setIsModalVisible(false)
        form.resetFields()
    }
    const usePost = useMutation({url: '/worker'})


    const handleOk = async () => {
        const values = await form.validateFields()
        usePost.mutate(values, {
            onSuccess: (newData) => {
                setIsModalVisible(false)

                queryClient.setQueryData('/worker', (oldData = []) =>
                    ({...oldData, results: [...oldData.results, newData]}))
            },
        })
    };

    return (<div>
        <Button type="primary" onClick={showModal}  icon={<FileAddOutlined/>}>
            إضافه جديد
        </Button>
        <Modal
            title="إصافة جديد"
            centered
            width={'70%'}
            destroyOnClose
            visible={isModalVisible}
            okText={"إضافة"}
            cancelText={"إلغاء"}
            onOk={handleOk}
            onCancel={onCancel}>
            <Form
                name="basic"
                form={form}
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                initialValues={{
                    status: "Active",
                }}
                autoComplete="off"
            >
                <WorkerForm form={form}/>
            </Form>
        </Modal>
    </div>);
}

export default AddWorker;
